(function () {
  'use strict';

  angular
    .module('services.sension', ['factories.mobileHelper', 'factories.alert'])
    .factory('Sension', Sension);

  Sension.$inject = ['$rootScope', 'MobileHelper', '$window', '$timeout', 'mtypes', '$interval', '$location', 'Utils', 'Alert', 'gettext'];

  function Sension($rootScope, MobileHelper, $window, $timeout, mtypes, $interval, $location, Utils, Alert, gettext) {
    var initParams = {};
    var isEngaged;
    var faceHidden = false;
    var mediaIdentifier;
    var sensionOn = false;
    var resourceBase = 'vendor/sension/';
    var engagementCheckInterval = null;
    var scoreModel = {};
    var flashPermissionsSelected = false;
    var slideCallback = null;

    // For some reason (there are several suspects ranging from a bug in IE11 to a bug in swfobject), IE11 has
    // issues with Flash calling JS when served cross-domain so don't serve from cloudfront if on IE11.
    var isIE11 = !!(navigator.userAgent.match(/Trident/) && !!navigator.userAgent.match(/rv:11/));
    if (!isIE11)
      resourceBase = ($window.mfConfig.cdnPath || '') + resourceBase;

    var service = {
      isCompatible: isCompatible,
      init: init,
      enabled: getEnabled,
      requireEngagement: getRequireEngagement,
      isEngaged: getIsEngaged,
      faceHidden: getFaceHidden,
      turnOn: turnOn,
      turnOff: turnOff,
      getEngagementFromFramework: getEngagementFromFramework,
      setupSlideCallback: setupSlideCallback,
      changedSlide: changedSlide,
      mediaSetup: mediaSetup,
      mediaPlaying: mediaPlaying,
      mediaPaused: mediaPaused,
      updateTimestamp: updateTimestamp,
      getAggregateEngagement: getAggregateEngagement
    };

    return service;

    ///////////////

    function isCompatible(cb) {
      if (MobileHelper.isMobileDevice())
        return cb(false, 'on-mobile');
      if (!$window.swfobject.hasFlashPlayerVersion('11.5'))
        return cb(false, 'no-flash');

      var hasCalledBack = false;

      // Just in case the SWF doesn't respond call back after 5 seconds reporting there's no flash.
      $timeout(function () {
        if (!hasCalledBack) {
          hasCalledBack = true;
          cb(false, 'no-flash');
        }
      }, 5000);

      $window.SensionEngagement.setParams({resourceBase: resourceBase});
      $window.SensionEngagement.hasCamera(function (hasCamera) {
        if (hasCalledBack)
          return;

        hasCalledBack = true;
        if (!hasCamera)
          return cb(false, 'no-camera');
        cb(true);
      });
    }

    function init(params) {
      initParams = _.defaults(params || {}, {
        isCompatible: false,
        isPreview: false,
        hasCompletionInfo: false,
        sensionUsage: mtypes.sensionUsage.none
      });
    }

    function getEnabled() {
      return initParams.isCompatible && !initParams.isPreview && !initParams.hasCompletionInfo &&
        initParams.sensionUsage != mtypes.sensionUsage.none;
    }

    function getRequireEngagement() {
      return getEnabled() && initParams.sensionUsage == mtypes.sensionUsage.requireEngagement;
    }

    function getIsEngaged() {
      return isEngaged || 0;
    }

    function getFaceHidden() {
      if (!flashPermissionsSelected) return true;
      return faceHidden || false;
    }

    function setIsEngaged(params) {
      if (params.faceHidden == faceHidden && params.isEngaged == isEngaged) return;
      isEngaged = params.isEngaged;
      faceHidden = params.faceHidden;
      $rootScope.$broadcast('sensionIsEngagedChanged', params);
    }

    function turnOn(cb) {
      sensionOn = true;
      var reason = initParams.sensionUsage == mtypes.sensionUsage.measureEngagement ?
        gettext('Help the trainer make their cModule better by ensuring you are in the camera’s view. Video will not be recorded nor streamed. To proceed, please click "Allow" below.') :
        gettext('This cModule requires the use of your webcam. Video will not be recorded nor streamed. To proceed, please click "Allow" below.');
      $window.SensionEngagement.init({
        customer: $window.mfConfig.sensionId,
        apiSecret: 'Not provided',
        mediaIdentifier: '',
        reason: reason,
        resourceBase: resourceBase,
        smoothScore: false
      });

      $window.SensionEngagement.permissionHandler(function () {
        flashPermissionsSelected = true;
        if ($window.SensionEngagement.userDisallowed) {
          if (initParams.sensionUsage == mtypes.sensionUsage.requireEngagement) {
            turnOff();
            init(null);
            Alert.show(gettext('CModule Requires Webcam'), gettext('This cModule requires the use of a webcam. You must click "Allow" to enable the use of your webcam to take this cModule.'));
            $location.path('#/dash');
          } else if (initParams.sensionUsage == mtypes.sensionUsage.measureEngagement) {
            callSlideCallback(true);
            turnOff();
            init(null);
            // Force a digest cycle so it sees that Sension is no longer enabled and updates UI accordingly.
            Utils.apply();
          }
        }
      });

      $window.SensionEngagement.startTracking();
      if (cb) cb();
    }

    function turnOff(cb) {
      if (!sensionOn) return;
      sensionOn = false;
      slideCallback = null;
      if ($window.SensionEngagement) {
        $window.SensionEngagement.userDisallowed = false;
        $window.SensionEngagement.stopTracking();
      }

      onSlideEnd();
      scoreModel = {};
      if (cb) cb();
    }

    function getEngagementFromFramework(cb) {
      setIsEngaged({
        faceHidden: $window.SensionEngagement.faceHidden,
        isEngaged: $window.SensionEngagement.currentEngagementScore
      });
      if (cb) cb(isEngaged);
    }

    function setupSlideCallback(cb) {
      // To make iPad and web APIs the same we need to be able to call this over and over again without doing anything
      // after the first time.
      if (slideCallback) return;

      slideCallback = cb;
      $window.SensionEngagement.scoreEngagementHandler(callSlideCallback);
    }

    function callSlideCallback(forceCallback) {
      if (!sensionOn) return;
      var newFaceHidden = $window.SensionEngagement.faceHidden;
      var newIsEngaged = $window.SensionEngagement.currentEngagementScore;
      if (newFaceHidden != faceHidden || newIsEngaged != isEngaged || forceCallback) {
        var params = {
          faceHidden: newFaceHidden,
          isEngaged: newIsEngaged
        };
        setIsEngaged(params);
        if (slideCallback) slideCallback(params);
      }
    }

    function changedSlide(frameId, cb) {
      onSlideEnd();

      mediaIdentifier = frameId;
      scoreModel[mediaIdentifier] = scoreModel[mediaIdentifier] || {averageMeasurement: 0, numMeasurements: 0};
      $window.SensionEngagement.setParams({
        mediaIdentifier: mediaIdentifier
      });

      engagementCheckInterval = $interval(onEngagementCheckTick, 250);

      if (cb) cb();
    }

    function mediaSetup(data, cb) {
      var duration = data.duration;
      $window.SensionEngagement.setParams({
        duration: duration
      });
      if (cb) cb();
    }

    function mediaPlaying(timestamp, cb) {
      $window.SensionEngagement.videoTimecodeDidChange(timestamp);
      $window.SensionEngagement.videoDidResume();
      if (cb) cb();
    }

    function mediaPaused(timestamp, cb) {
      $window.SensionEngagement.videoTimecodeDidChange(timestamp);
      $window.SensionEngagement.videoDidPause();
      if (cb) cb();
    }

    function updateTimestamp(timestamp, cb) {
      $window.SensionEngagement.videoTimecodeDidChange(timestamp);
      if (cb) cb();
    }

    function getAggregateEngagement() {
      if (!scoreModel || !scoreModel[mediaIdentifier] || scoreModel[mediaIdentifier].numMeasurements == 0)
        return null;
      return Math.round(scoreModel[mediaIdentifier].averageMeasurement * 100);
    }

    function onSlideEnd() {
      $interval.cancel(engagementCheckInterval);
      engagementCheckInterval = null;
    }

    function onEngagementCheckTick() {
      // Don't calculate engagement score if the camera's not on or the framework thinks the user's face is hidden
      if (!$window.SensionEngagement.cameraOn || faceHidden) return;
      var averageMeasurement = scoreModel[mediaIdentifier].averageMeasurement;
      var numMeasurements = scoreModel[mediaIdentifier].numMeasurements;
      scoreModel[mediaIdentifier].averageMeasurement = (averageMeasurement * numMeasurements + isEngaged) / (numMeasurements + 1);
      scoreModel[mediaIdentifier].numMeasurements = numMeasurements + 1;
    }
  }
})();
